import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../UniformComponents/Modal'
import ModalFooter from '../../UniformComponents/ModalFooter'
import Input from '../form/Input'
import TemplateAccess from '../TemplateAccess'
import EmailTemplateRespondents from './EmailTemplateRespondents'
import Button from '../../UniformComponents/Button'
import CKeditor5 from '../CKeditor5'
import Typography from '../../UniformComponents/Typography'

import '../Distribute/EmailBuilder/emailBuilder.scss'

@observer
class CreateEmailTemplateModal extends PureComponent {
    render() {
        const { templateSearchStore, store } = this.props
        const tabs = templateSearchStore.setTabs()
        return (
            <Modal
                show={templateSearchStore.createEmailTemplateModalVisible}
                onClose={templateSearchStore.closeCreateTemplateEmailModal}
            >
                <div className="question-builder-head form-tabs-header">
                            <h2 className="title">
                                {i18n.t('distributionEmailBuilder.create')}
                            </h2>
                            {/* <div className="tab-btns">
                                {tabs.map((t) => (
                                    <Button
                                        key={t.name}
                                        cssClass={`tab ${templateSearchStore.tabName === t.name ? 'selected' : ''}`}
                                        label={t.label}
                                        onClick={() => {
                                            templateSearchStore.toggleTab(t.name)
                                        }}
                                    />
                                ))}
                            </div> */}
                        </div>
                

                {/* {templateSearchStore.tabName === 'email'
                    ? ( */}
                        <div className="email-builder-modal-content">
                            <Input
                                label={i18n.t('sch_email_subject')}
                                placeholder={i18n.t('form.input.placeholder')}
                                onBlur={templateSearchStore.changeEmailSubject}
                                defaultValue={templateSearchStore.emailSubject}
                                autoFocus
                                validate={({value}) => (!!value.length)}
                                emptyError={'Email subject cannot be empty.'}
                            />

                            <Input
                                label={i18n.t('sch_email_send_from_label')}
                                defaultValue={templateSearchStore.emailSender}
                                onBlur={templateSearchStore.changeEmailSender}
                            />

                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography type="b">
                                    {i18n.t('distributionEmailBuilderModal.enterMessage')}
                                </Typography>

                                <br />
                                <div style={{ border: templateSearchStore.emptyBodyError ? '1px solid #FE3A29' : '' }}>
                                    <CKeditor5
                                        data={templateSearchStore.emailBody}
                                        onBlur={templateSearchStore.changeEmailBody}
                                        toolbar="emailSchedule"
                                        id='1234'
                                        locales={[]}
                                        store={store}
                                        onSourceToggle={templateSearchStore.editorSourceToggle}
                                    />
                                </div>

                                {templateSearchStore.emptyBodyError
                                    ? (
                                        <div style={{ marginTop: 10, marginLeft: 23 }}>
                                            <Typography color="error">{i18n.t('templates.emptyEmailBodyError')}</Typography>
                                        </div>
                                    ) : null}
                            </div>
                        </div>
                    {/* ) : null} */}
                
                {/* {templateSearchStore.tabName === 'portfolios'
                    ? ( */}
                        <div>
                            <br />

                            <TemplateAccess
                                store={store}
                                templateSearchStore={templateSearchStore}
                                isEmail
                                isNewTemplate
                            />
                        </div>
                    {/* ) : null} */}
                
                {/* {templateSearchStore.tabName === 'eventtypes' */}
                    {/* ? ( */}
                        <div>
                            <br />

                            <EmailTemplateRespondents
                                store={store}
                                templateSearchStore={templateSearchStore}
                                hasRequiredError={templateSearchStore.hasRespondentRequiredError}
                            />
                        </div>
                    {/* ) : null} */}

                <ModalFooter>
                    <div className="email-builder-modal-footer-buttons">
                        <React.Fragment>
                            <Button cssClass="regular tertiary" onClick={templateSearchStore.closeCreateTemplateEmailModal}>
                                {i18n.t('cancel')}
                            </Button>

                            <div style={{ display: 'flex', gap: 8 }}>
                                <Button
                                    cssClass="regular tertiary"
                                    onClick={templateSearchStore.showTestEmailModal}
                                    label={i18n.t('distributionEmailBuilderModal.sendTestEmail')}
                                    icon="far fa-paper-plane-top"
                                    disabled={!templateSearchStore.emailBody.length || !templateSearchStore.emailSubject.length || !templateSearchStore.emailSender.length}
                                />

                                <Button
                                    label={i18n.t('save')}
                                    icon="far fa-floppy-disk"
                                    cssClass="regular primary"
                                    disabled={templateSearchStore.isSaving}
                                    onClick={templateSearchStore.saveTemplate}
                                />
                            </div>
                        </React.Fragment>
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default CreateEmailTemplateModal
